"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _services = require("../../services");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ButtonRight = _styledComponents.default.div(props => (0, _styledComponents.css)`
      display: flex;
      justify-content: ${props.buttonStyle};
      width: 100%;
    `);
const QuestionFooterNextButton = _ref => {
  var _buttonTheme$appearan, _buttonTheme$appearan2;
  let {
    buttonTheme,
    nextButtonAppearance,
    onNext,
    nextButtonColumns,
    nextButtonText,
    buttonStyle = '',
    nextButtonState = ''
  } = _ref;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const buttonText = nextButtonText || _services.Services.locale.localeString('Questionnaire.ButtonNext');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    className: "singleButtonContainer"
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan = buttonTheme.appearance) === null || _buttonTheme$appearan === void 0 ? void 0 : _buttonTheme$appearan[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow,
    "data-testid": "small-screen"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: buttonText,
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(ButtonRight, {
    buttonStyle: buttonStyle
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: nextButtonColumns
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan2 = buttonTheme.appearance) === null || _buttonTheme$appearan2 === void 0 ? void 0 : _buttonTheme$appearan2[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow,
    "data-testid": "large-screen"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: buttonText,
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  }))))));
};
var _default = QuestionFooterNextButton;
exports.default = _default;
QuestionFooterNextButton.propTypes = {
  buttonTheme: _propTypes.default.shape({
    appearance: _propTypes.default.object
  }),
  nextButtonAppearance: _propTypes.default.string,
  onNext: _propTypes.default.func.isRequired,
  nextButtonColumns: _propTypes.default.number,
  buttonStyle: _propTypes.default.string,
  nextButtonState: _propTypes.default.string,
  nextButtonText: _propTypes.default.string
};